<template>
  <div class="jiayouba-container">
    <!-- 公司账户余额查询 -->
    <Card dis-hover style="margin-bottom: 16px;">
      <p slot="title">物流公司账户余额查询</p>
      
      <Form :model="companyForm" :label-width="100" inline>
        <FormItem label="油品类型" prop="fuel_type">
          <Select v-model="companyForm.fuel_type" style="width: 150px;" clearable>
            <Option value="">全部</Option>
            <Option value="GENERAL">通用</Option>
            <Option value="DIESEL">柴油</Option>
            <Option value="LNG">天然气</Option>
            <Option value="MARKETING">营销</Option>
          </Select>
        </FormItem>
        
        <FormItem>
          <Button type="primary" @click="handleQueryCompanyBalance" :loading="companyLoading">
            查询余额
          </Button>
        </FormItem>
      </Form>

      <div v-if="companyBalance !== null" style="margin-top: 16px; padding: 16px; background: #f5f7fa; border-radius: 4px;">
        <Row>
          <Col span="8">
            <div style="text-align: center;">
              <div style="color: #808695; font-size: 14px;">可用余额</div>
              <div style="color: #19be6b; font-size: 24px; font-weight: bold; margin-top: 8px;">
                ¥{{ companyBalance.availableBalanceYuan || '0.00' }}
              </div>
            </div>
          </Col>
          <Col span="8">
            <div style="text-align: center;">
              <div style="color: #808695; font-size: 14px;">冻结金额</div>
              <div style="color: #ff9900; font-size: 24px; font-weight: bold; margin-top: 8px;">
                ¥{{ companyBalance.frozenBalanceYuan || '0.00' }}
              </div>
            </div>
          </Col>
          <Col span="8">
            <div style="text-align: center;">
              <div style="color: #808695; font-size: 14px;">账户总额</div>
              <div style="color: #2d8cf0; font-size: 24px; font-weight: bold; margin-top: 8px;">
                ¥{{ companyBalance.totalBalanceYuan || '0.00' }}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Card>

    <!-- 对账单下载 -->
    <Card dis-hover style="margin-top: 16px;">
      <p slot="title">对账单下载</p>

      <Form :model="statementForm" :label-width="100" inline>
        <FormItem label="账单日期" prop="billDate">
          <DatePicker
              v-model="statementForm.billDate"
              type="date"
              format="yyyy-MM-dd"
              placeholder="选择账单日期"
              style="width: 200px;"
          />
        </FormItem>

        <FormItem>
          <Button type="primary" @click="handleDownloadStatement" :loading="statementLoading">
            下载对账单
          </Button>
        </FormItem>
      </Form>
    </Card>
    <!-- 交易记录查询 -->
    <Card dis-hover>
      <p slot="title">交易记录查询</p>
      
      <Form :model="tradeForm" :label-width="100" inline>
        <FormItem label="司机ID" prop="open_id">
          <Input v-model="tradeForm.open_id" placeholder="请输入司机ID" style="width: 200px;" clearable />
        </FormItem>
        
        <FormItem label="物流单号" prop="logistics_no">
          <Input v-model="tradeForm.logistics_no" placeholder="请输入物流单号" style="width: 200px;" clearable />
        </FormItem>
        
        <FormItem label="交易时间" prop="timeRange">
          <DatePicker 
            v-model="tradeForm.timeRange" 
            type="datetimerange" 
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间范围"
            style="width: 300px;"
            @on-change="handleTimeRangeChange"
          />
        </FormItem>
        
        <FormItem>
          <Button type="primary" @click="handleQueryTrade" :loading="tradeLoading">
            查询交易
          </Button>
          <Button @click="resetTradeForm" style="margin-left: 8px;">
            重置
          </Button>
        </FormItem>
      </Form>

      <Table 
        :columns="tradeColumns" 
        :data="tradeList" 
        :loading="tradeLoading"
        style="margin-top: 16px;"
      />

      <div style="margin-top: 16px; text-align: right;">
        <Page 
          :total="tradeTotal" 
          :current="tradePage"
          :page-size="tradePageSize"
          show-total
          show-elevator
          show-sizer
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSizeChange"
        />
      </div>
    </Card>

  </div>
</template>

<script>
export default {
  name: 'Jiayouba',
  data() {
    return {
      // 公司账户余额查询
      companyForm: {
        fuel_type: 'GENERAL'
      },
      companyBalance: null,
      companyLoading: false,

      // 交易记录查询
      tradeForm: {
        open_id: '',
        logistics_no: '',
        timeRange: []
      },
      tradeColumns: [
        { title: '交易流水号', key: 'transaction_id', align: 'center' },
        { title: '物流单号', key: 'logistics_no', align: 'center' },
        { title: '司机ID', key: 'logistics_open_id', align: 'center' },
        { title: '油品名称', key: 'goods_name', align: 'center' },
        { title: '订单金额(元)', key: 'order_amount_yuan', align: 'center' },
        { title: '交易时间', key: 'trx_time', align: 'center' },
        { title: '加油站', key: 'shop_name', align: 'center' },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.handleDownloadEreceipt(params.row.transaction_id)
                }
              }
            }, '下载电子回单')
          }
        }
      ],
      tradeList: [],
      tradeTotal: 0,
      tradePage: 1,
      tradePageSize: 10,
      tradeLoading: false,

      // 对账单下载
      statementForm: {
        billDate: null
      },
      statementLoading: false
    }
  },
  created() {
    // 初始化默认7天的时间范围
    const now = new Date()
    const sevenDaysAgo = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000)
    
    // 设置开始时间为0点
    sevenDaysAgo.setHours(0, 0, 0, 0)
    
    // 设置结束时间为23:59:59
    now.setHours(23, 59, 59, 999)
    
    this.tradeForm.timeRange = [sevenDaysAgo, now]
  },
  methods: {
    // 查询公司余额
    async handleQueryCompanyBalance() {
      this.companyLoading = true
      try {
        const params = {}
        if (this.companyForm.fuel_type) {
          params.fuel_type = this.companyForm.fuel_type
        }
        
        const res = await this.$commonFun.postProxy('admin/jiayouba/queryCompanyBalance', params)
        if (res.code === 200) {
          this.companyBalance = res.data
          this.$Message.success('查询成功')
        } else {
          this.$Message.error(res.msg || '查询失败')
        }
      } catch (error) {
        this.$Message.error('查询异常：' + error.message)
      } finally {
        this.companyLoading = false
      }
    },

    // 查询交易记录
    async handleQueryTrade() {
      // 验证必须选择时间
      if (!this.tradeForm.timeRange || this.tradeForm.timeRange.length !== 2) {
        this.$Message.warning('请选择时间范围')
        return
      }

      // 验证时间范围不能超过7天
      const selectedStartTime = new Date(this.tradeForm.timeRange[0])
      const selectedEndTime = new Date(this.tradeForm.timeRange[1])
      const diffDays = (selectedEndTime - selectedStartTime) / (1000 * 60 * 60 * 24)
      
      if (diffDays > 7) {
        this.$Message.warning('时间范围最大为7天')
        return
      }

      this.tradeLoading = true
      try {
        const params = {
          open_id: this.tradeForm.open_id,
          logistics_no: this.tradeForm.logistics_no,
          page_size: this.tradePageSize,
          current_page: this.tradePage
        }

        // 创建新的 Date 对象并设置时间
        const adjustedStartTime = new Date(this.tradeForm.timeRange[0])
        adjustedStartTime.setHours(0, 0, 0, 0)
        
        const adjustedEndTime = new Date(this.tradeForm.timeRange[1])
        adjustedEndTime.setHours(23, 59, 59, 999)
        
        params.trx_time_from = this.formatDateTime(adjustedStartTime)
        params.trx_time_to = this.formatDateTime(adjustedEndTime)

        const res = await this.$commonFun.postProxy('admin/jiayouba/queryTrade', params)
        if (res.code === 200) {
          this.tradeList = res.data.items || []
          this.tradeTotal = (res.data.paginator && res.data.paginator.totalSize) || 0
          this.$Message.success(`查询成功，共 ${this.tradeTotal} 条记录`)
        } else {
          this.$Message.error(res.msg || '查询失败')
        }
      } catch (error) {
        this.$Message.error('查询异常：' + error.message)
      } finally {
        this.tradeLoading = false
      }
    },

    // 重置交易表单
    resetTradeForm() {
      this.tradeForm = {
        open_id: '',
        logistics_no: '',
        timeRange: []
      }
      this.tradeList = []
      this.tradeTotal = 0
      this.tradePage = 1
    },

    // 下载电子回单
    async handleDownloadEreceipt(transactionId) {
      if (!transactionId) {
        this.$Message.warning('交易订单号不能为空')
        return
      }

      try {
        const res = await this.$commonFun.postProxy('admin/jiayouba/downloadEreceipt', {
          transaction_id: transactionId
        })

        if (res.code === 200 && res.data && res.data.download_url) {
          // 直接打开下载链接
          window.open(res.data.download_url, '_blank')
          this.$Message.success('开始下载电子回单')
        } else {
          this.$Message.error(res.msg || '获取下载链接失败')
        }
      } catch (error) {
        this.$Message.error('下载异常：' + error.message)
      }
    },

    // 页码变化
    handlePageChange(page) {
      this.tradePage = page
      this.handleQueryTrade()
    },

    // 每页数量变化
    handlePageSizeChange(pageSize) {
      this.tradePageSize = pageSize
      this.tradePage = 1
      this.handleQueryTrade()
    },

    // 格式化日期时间
    formatDateTime(date) {
      // 确保是 Date 对象
      if (!(date instanceof Date)) {
        date = new Date(date)
      }
      
      // 检查是否为有效日期
      if (isNaN(date.getTime())) {
        return ''
      }
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },

    // 下载对账单
    async handleDownloadStatement() {
      if (!this.statementForm.billDate) {
        this.$Message.warning('请选择账单日期')
        return
      }

      this.statementLoading = true
      try {
        // 格式化日期为 yyyy-MM-dd 格式
        const billDate = this.formatBillDate(this.statementForm.billDate)
        
        // 生成文件名
        const fileName = `交易对账单_${billDate}.csv`
        
        // 使用 downFileByPost 方法处理文件流下载
        await this.$commonFun.downFileByPost('admin/jiayouba/downloadTradeBill', {
          bill_date: billDate
        }, fileName)
        
        this.$Message.success('对账单下载成功')
      } catch (error) {
        this.$Message.error('下载异常：' + error.message)
      } finally {
        this.statementLoading = false
      }
    },

    // 格式化账单日期
    formatBillDate(date) {
      if (!date) return ''
      
      // 确保是 Date 对象
      if (!(date instanceof Date)) {
        date = new Date(date)
      }
      
      // 检查是否为有效日期
      if (isNaN(date.getTime())) {
        return ''
      }
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.jiayouba-container {
  padding: 16px;
}
</style>
